require('datatables.net');
require('datatables.net-responsive');
require('datatables.net-datetime');
require('datatables.net-select');
require('datatables.net-buttons');
require('datatables.net-fixedheader');
